<template>
    <div class="features-page">
        <cinema @cinema-toggle="cinemaToggle" style="margin-bottom: 70px"></cinema>
        <restaurant @restaurant-toggle="restaurantToggle" style="margin-bottom: 70px"></restaurant>
        <sport @sport-toggle="sportToggle" style="margin-bottom: 70px"></sport>
        <entertainment @enteratainment-toggle="entertainmentToggle" style="margin-bottom: 70px"></entertainment>
    </div>
</template>

<script>
  import cinema from "../component/featuresPage/cinema";
  import restaurant from "../component/featuresPage/restaurant";
  import sport from "../component/featuresPage/sport";
  import entertainment from "../component/featuresPage/entertainment";
  import {mapActions} from 'vuex'
    export default {
        name: "featuresPage",
        components:{
          cinema,
          restaurant,
          sport,
          entertainment,
          cinemaLoading:false,
          restaurantLoading:false,
          entertainmentLoading:false,
          sportLoading:false,
          loading:false
        },
      beforeMount() {
          this.setLoading(true)
      },

      methods:{
        ...mapActions({
          getIntroductionReq:'introduceUnitsAndFeatures/fetchIntroduceUnit',
          getIntroduceReq:'introduceStore/fetchIntroduce',
          setLoading : 'setLoading'
        }),
       cinemaToggle(bool){
          this.loading = bool
         this.setLoading(!bool)
       },

        restaurantToggle(bool){
          this.restaurantLoading = bool
          this.loading = !this.loading

        },
        entertainmentToggle(bool){
          this.entertainmentLoading = bool
          this.loading = !this.loading

        },
        sportToggle(bool){
          this.sportLoading = bool
          this.loading = !this.loading

        },
      },
      watch : {
          loading : function(){
            if(this.sportLoading && this.entertainmentLoading && this.cinemaLoading && this.restaurantLoading){
              this.setLoading(false)
            }
            else{
              this.setLoading(true)
            }
          },
        cinemaLoading : function  ()
          {
          // console.log(this.sportLoading,'watch');
        }
        }
    }
</script>

<style scoped>

</style>
